import './init';

import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { apolloClient } from './apollo';
import './i18n';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import './sentry';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const app: React.ReactNode = (
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ApolloProvider>
  </React.StrictMode>
);

root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
